export const optionSx =
  (active = false) =>
  (t) => ({
    cursor: "pointer",

    // Only apply hover styles on hover-capable devices
    "@media (hover: hover)": {
      "&:hover": {
        bgcolor: active ? t.palette.action.selected : t.palette.action.hover,
      },
    },

    // Autocomplete-ish sizing/typography
    px: 1.5,
    py: 0.5,
    typography: "body1",
    gap: 1,

    // Selected state
    "&.Mui-selected": {
      bgcolor: t.palette.action.selected,
    },
    // Keep same color on hover when selected
    "&.Mui-selected:hover": {
      bgcolor: t.palette.action.selected,
    },

    // Base background
    bgcolor: active ? t.palette.action.selected : "transparent",
  });
